import router from 'next/router';
import PostItem from 'global/StreamWidget/Post';

import useGetStream from './useGetStream';
import StreamSkeleton from './StreamSkeleton';

import { StreamWrapper } from './guest.styled';

interface IStream {
  username: string;
}

export default function Stream({ username }: IStream) {
  const responseStream = useGetStream(username);

  const handleComment = () => {
    router.push('/login');
  };

  if (responseStream.isLoading) {
    return <StreamSkeleton />;
  }

  if (!responseStream.data) {
    return null;
  }

  return (
    <StreamWrapper>
      {responseStream?.data?.map((post: any, idx: number) => (
        <>
          <PostItem
            post={post}
            key={post.postid}
            onComment={handleComment}
            isFirstPost={idx === 0}
            dataCyName={`stream-guest-user-${post.postid}`}
            entryPoint="guest-user"
          />
        </>
      ))}
    </StreamWrapper>
  );
}
